import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CarService } from 'src/app/services/car/car.service';
import { UploadComponent } from "../../layout/upload/upload.component";
import { environment } from '../../../../environments/environment'
import { NewsService } from 'src/app/services/news/news.service';

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, NgbPaginationModule, UploadComponent],
  templateUrl: './news.component.html',
  styleUrl: './news.component.css'
})
export class NewsComponent {
  data: any
  load = false
  partForm: FormGroup
  page = 1;
  pageSize = 20;
  paginatedData: any[] = [];

  url = environment.apiDomain

  constructor(
    private NewsService: NewsService,
    private CarService: CarService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.partForm = this.fb.group({
      id: [''],
      title_ka: [''],
      title_en: [''],
      title_ru: [''],
      description_ka: [''],
      description_en: [''],
      description_ru: [''],
      image: [''],
      folder: [''],
    });
    this.get();
  }

  get(){
    this.load = true
    this.NewsService.get().subscribe(
      (res: any) => {
        this.data = res
        this.paginate();
        this.load = false
        console.log(res)
      }
    ),
    (error: any) => {
      this.load = false
      console.log(error)
    }
  }



  paginate() {
    const start = (this.page - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedData = this.data.slice(start, end);
  }

  openModal(content: any) {
    this.partForm.reset();
    this.modalService.open(content, { size: 'lg' });
  }

   onFileUploaded(fileName: string) {
    this.partForm.patchValue({ image: fileName });
  }

  savePart(modal: any) {
    const partId = this.partForm.get('id')?.value;
    if (partId) {
      this.NewsService.update(partId, this.partForm.value).subscribe(
        (res: any) => {
          modal.close();
          // this.partForm.reset();
          this.get();
        },
        (error: any) => {
          // handle error if needed
        }
      );
    } else {
      this.NewsService.create(this.partForm.value).subscribe(
        (res: any) => {
          modal.close();
          this.partForm.reset();
          this.get();
        },
        (error: any) => {
          // handle error if needed
        }
      );
    }
  }

  editPart(part: any, modal: any) {
    this.partForm.patchValue(part);
    this.modalService.open(modal, { size: 'lg' });
  }

  deletePart(id: any) {
    if(confirm('ნამდვილათ გსურთ წაშლა')){
      this.NewsService.delete(id).subscribe(
        () => {
          this.get();
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }
}
